import type { Provider } from './types';

import gmailIcon from 'assets/images/logos/gmail.svg';
import googleIcon from 'assets/images/logos/google.svg';

export const gmail: Provider = {
  label: 'Gmail',
  icon: gmailIcon,
  ssoLabel: 'Google',
  ssoIcon: googleIcon,
};
